import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

const licenseUserGroupsSlice = createSlice({
    name: 'licenseUserGroups',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default licenseUserGroupsSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = licenseUserGroupsSlice.actions;
export const selectFilters = (state: RootState) => state.licenseUserGroups.filters;
